<template src="./index.html">
</template>

<script>
	import data from './data.js'
	import upprocess from '../../../common/upProcess/index.vue'
	import uploadFile from '../../../common/uploadFile/index.vue'
	import updateywkm from '../../../common/updateywkm/index.vue'
	import config from '../../../../../configHttp.js'
    import { importExcel } from '@/api/contract';
	export default{
		components:{
			upprocess,uploadFile,updateywkm
		},
		data:function(){
			return{
				uptype:1,
				typex:'0',
				importType:"0",
				typeing:data.typeing,
				mboptions:data.mboptions,

				// count: 5,
				// successCount:0,
				// successdata:{},
				// batchNum: "",
				// timer:null,
				upformdata: {}, //文件信息
			}
		},
		methods:{
			forbackup(){
				this.$refs['uploadfileRef'].forrefresh()
				this.uptype=1
				 clearInterval(this.timer);
			},
			forchooseindex(index){
					this.$emit("forchooseindex",index)
			},
			toCustomTemplate(){
				this.$router.push("/CustomTemplate")
			},
			getuploadparams(e){
				this.upformdata = e
				// 获取到的文件信息
			},
			fordownloadmb(){
				let params={
					downUrl:config.baseURL+"contract/template/download",
					typeObj:{
						toForm:false,
						fileName:"合同台账标准模板"+ this.$timestampToStr(new Date(),'yyyyMMdd'),
						fileType:'xlsx',
						failUrl:this.$winURl
					},
				}
                this.$downloadcommon(params);
				///
			},
			importIinvExcel(){
				if (this.$emptyandnull(this.upformdata.upfile)) {
					this.$message.error("请选择要上传的文件")
					return false
				}
				let formData = {
					importType: this.importType,
					file: this.upformdata.upfile
				};
                importExcel(formData).then(res => {
                    if (res.data.code == 1) {
                        //如果成功数量为0则跳转至结果页面
                        if (!res.data.data.hasOwnProperty("successCount")) {
                            this.$message.error(
                                res.data.data.error
                            );
                            return;
                        }
                        if (res.data.data.successCount == 0 || !res.data.data.successCount) {
                            this.$message.error( "当前导入文件成功条数为0，具体错误信息可到上传结果界面查看")
                        } else {
                            this.$emit("forchooseindex",1)
                            if (res.data.data.errorCount > 0) {
                                this.$message.warning(res.data.msg +",成功条数:" + res.data.data.successCount);
                            } else  {
                                this.$message.success(res.data.msg +",成功条数:" + res.data.data.successCount);
                            }
                            this.batchNum = res.data.data.batchNo;
                            this.successdata = {
                                successCount: res.data.data.successCount,
                                errorCount: res.data.data.errorCount,
                            };
                            this.timer = setInterval(() => {
                                this.count--;
                                if (self._isDestroyed) {
                                    clearInterval(this.timer);
                                    return false;
                                }
                                if (this.count == 0) {
                                    this.$refs["uploadfileRef"].forrefresh();
                                    this.uptype = 1;
                                    clearInterval(this.timer);
                                }
                            }, 1000);
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
			},
		}
	}
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>